import React from 'react';
import { CheckIcon, GiftIcon, LockIcon, ZapIcon, ShieldCheckIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { volumes } from '../../data/volumes';
import { bonuses } from '../../data/bonuses';
import { MOCKUP_URL } from '../../data/offer';
export function Offer() {
  return <section id="offer" className="bg-ink py-16 sm:py-24" aria-labelledby="offer-title" data-id="element-236" data-mp="3a68i7nufqaam">
      <div className="mx-auto max-w-3xl px-5" data-id="element-237" data-mp="3f40d8qqdmcj1">
        <div className="text-center" data-id="element-238" data-mp="3f2p9gqwxl4rx">
          <p className="font-display text-lg font-bold uppercase tracking-[0.06em] text-volt sm:text-xl" data-id="element-239" data-mp="3jvidfckks92y">
            Your complete HVAC electrical troubleshooting system
          </p>
          <h2 id="offer-title" className="mt-2 font-display text-[44px] font-extrabold uppercase leading-[0.95] text-white sm:text-6xl" data-id="element-240" data-mp="3svydsd60v03l">
            Everything included for just <span className="text-amber" data-id="element-241" data-mp="1pwxnq779gb3">$27</span>
          </h2>
        </div>

        <div className="mt-10 overflow-hidden rounded-[28px] border-2 border-volt bg-panel shadow-[0_0_0_6px_rgba(30,167,255,0.12)]" data-id="element-242" data-mp="1km9kmzrjfzrz">
          <div className="bg-white p-4" data-id="element-243" data-mp="1fohuobagenqf">
            <img src={MOCKUP_URL} alt="All 6 volumes and 5 bonuses" className="mx-auto w-full max-w-md" data-id="element-244" data-mp="1bk0aib06m8f4" />
          </div>

          <div className="p-5 sm:p-8" data-id="element-245" data-mp="16n0fcv4veq2s">
            <h3 className="font-display text-2xl font-bold uppercase text-volt" data-id="element-246" data-mp="16o1tx9l3hup9">Your 6 practical volumes</h3>
            <ul className="mt-3 space-y-2.5" data-id="element-247" data-mp="1zacpu6xrb7fq">
              {volumes.map(v => <li key={v.number} className="flex items-start gap-2.5 text-[16px] text-white" data-id="element-248" data-mp="1zcqkieoiyhmr">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-249" data-mp="1uhjprwd8gn9z" />
                  <span data-id="element-250" data-mp="1piqgkg4zbifm">
                    <strong data-id="element-251" data-mp="2n0gwyoa5lpbh">Volume {v.number}</strong> — {v.title}
                  </span>
                </li>)}
            </ul>

            <h3 className="mt-7 font-display text-2xl font-bold uppercase text-amber" data-id="element-252" data-mp="2i7xhflrwok41">Your 5 professional bonuses</h3>
            <ul className="mt-3 space-y-2.5" data-id="element-253" data-mp="317k33e4nojad">
              {bonuses.map(b => <li key={b.number} className="flex items-start gap-2.5 text-[16px] text-white" data-id="element-254" data-mp="363secgfqfsc9">
                  <GiftIcon className="mt-0.5 h-5 w-5 shrink-0 text-amber" aria-hidden="true" data-id="element-255" data-mp="2scx34xhrgz5i" />
                  {b.title}
                </li>)}
            </ul>

            <div className="mt-7 grid grid-cols-3 divide-x divide-line rounded-2xl bg-ink py-4 text-center ring-1 ring-line" data-id="element-256" data-mp="2ie7uzwfo2t2g">
              {[['6', 'Practical volumes'], ['5', 'Professional bonuses'], ['1', 'Five-stage workflow']].map(([n, label]) => <div key={label} className="px-2" data-id="element-257" data-mp="2dg6e9i5pr5u5">
                  <p className="font-display text-4xl font-extrabold text-white" data-id="element-258" data-mp="7met8grgocai">{n}</p>
                  <p className="text-xs font-semibold uppercase leading-tight text-mist" data-id="element-259" data-mp="bo9ph6ujbzhf">{label}</p>
                </div>)}
            </div>

            <div className="mt-8 text-center" data-id="element-260" data-mp="1w6u0ytojs8rz">
              <p className="font-display text-xl font-bold uppercase tracking-wide text-mist" data-id="element-261" data-mp="1s5ijxcjqovve">Today only</p>
              <p className="font-display text-[96px] font-extrabold leading-none text-amber sm:text-[120px]" data-id="element-262" data-mp="25wwztaicogy8">
                $27<span className="ml-1 align-top text-2xl text-white sm:text-3xl" data-id="element-263" data-mp="214m28eb3178u">USD</span>
              </p>
              <p className="mt-1 text-[16px] font-semibold text-white" data-id="element-264" data-mp="2ft8h6ewsrwzj">
                One-time payment · No subscription · Instant digital access
              </p>
              <p className="mx-auto mt-3 flex max-w-sm items-center justify-center gap-2 rounded-full bg-volt/10 px-4 py-2 text-sm font-semibold text-volt ring-1 ring-volt/40" data-id="element-265" data-mp="2ovriuvouk3k7">
                <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-266" data-mp="2jubtirfmzaw0" />
                Automatic conversion to your local currency
              </p>
            </div>

            <ScarcityBar data-id="element-267" data-mp="pjyiqq6rii39" />

            <div className="mt-6" data-id="element-268" data-mp="rwslmvmtnyev">
              <CtaButton label="Yes! I want my HVAC troubleshooting blueprint" data-id="element-269" data-mp="rxk8ni2csntj" />
            </div>

            <Countdown data-id="element-270" data-mp="vxm61f122v30" />

            <p className="mt-5 text-center text-[15px] font-medium text-white" data-id="element-271" data-mp="vwszof60e7le">
              Get the complete 6-volume system + all 5 bonuses for $27
            </p>
            <ul className="mt-4 grid grid-cols-1 gap-2 text-sm font-semibold text-mist sm:grid-cols-3" data-id="element-272" data-mp="15wtlc7rcozsr">
              <li className="flex items-center justify-center gap-1.5" data-id="element-273" data-mp="89kwc2s558m0">
                <LockIcon className="h-4 w-4 text-ok" aria-hidden="true" data-id="element-274" data-mp="d7mnzc3mug93" /> Secure checkout
              </li>
              <li className="flex items-center justify-center gap-1.5" data-id="element-275" data-mp="i6h60bts00s5">
                <ZapIcon className="h-4 w-4 text-amber" aria-hidden="true" data-id="element-276" data-mp="i560a6grsiye" /> Instant delivery
              </li>
              <li className="flex items-center justify-center gap-1.5" data-id="element-277" data-mp="3lnzbwdpzmxpx">
                <ShieldCheckIcon className="h-4 w-4 text-volt" aria-hidden="true" data-id="element-278" data-mp="3lllh85z7zniw" /> 7-day guarantee
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}